// extracted by mini-css-extract-plugin
module.exports = {"feed_wrapper":"ProductFeedList_feed_wrapper__FOpvy","feed_container":"ProductFeedList_feed_container__ZxLaN"};